module.exports = __webpack_public_path__ + "media/155.e7016a26.mp3";